import { createFileRoute } from '@tanstack/react-router';
import { SmartRedirect } from 'src/features/auth/contexts/SmartRedirect';
import LoginSignUpCard from 'src/features/auth/components/LoginSignUpCard';
import { useAuthPageData } from 'src/shared/hooks/useAuthPageData';

export const Route = createFileRoute('/_auth/signup')({
  head: () => ({
    meta: [{ title: 'Sign Up | Tekst' }],
  }),
  component: SignupPage,
});

function SignupPage() {
  const { logo, dimensions, authOptions } = useAuthPageData();

  return (
    <SmartRedirect>
      <LoginSignUpCard variant="signup" logo={logo} dimensions={dimensions} authOptions={authOptions} />
    </SmartRedirect>
  );
}
